function useIsPartner(team) {
  return team && team.headcount_partner;
}

export default useIsPartner;
